import { addNavMenuSection } from "@vendure/admin-ui/core";

export default [
  addNavMenuSection(
    {
      id: "content",
      label: "CMS",
      items: [
        {
          id: "cms-homepage",
          label: "Startseite",
          routerLink: ["/extensions/cms"],
          icon: "note",
          requiresPermission: "UpdateSettings"
        },
        {
          id: "cms-product-faq-base",
          label: "Globale FAQs",
          routerLink: ["/extensions/cms/produkt-faq-basis"],
          icon: "help-info",
          requiresPermission: "UpdateSettings"
        },
        {
          id: "cms-product-faqs",
          label: "Produkt-FAQs",
          routerLink: ["/extensions/cms/produkt-faqs"],
          icon: "tasks",
          requiresPermission: "UpdateSettings"
        },
        {
          id: "cms-pages",
          label: "Seiten",
          routerLink: ["/extensions/cms/seiten"],
          icon: "file-group",
          requiresPermission: "UpdateSettings"
        },
        {
          id: "cms-press",
          label: "Presse",
          routerLink: ["/extensions/cms/presse"],
          icon: "newspaper",
          requiresPermission: "UpdateSettings"
        },
        {
          id: "cms-regions",
          label: "Regionen",
          routerLink: ["/extensions/cms/regionen"],
          icon: "map-marker",
          requiresPermission: "UpdateSettings"
        },
        {
          id: "cms-collection-content",
          label: "Sortiment-Inhalte",
          routerLink: ["/extensions/cms/sortimente"],
          icon: "tag",
          requiresPermission: "UpdateSettings"
        },
        {
          id: "cms-site-notice",
          label: "Hinweisleiste",
          routerLink: ["/extensions/cms/hinweisleiste"],
          icon: "bell",
          requiresPermission: "UpdateSettings"
        },
        {
          id: "cms-benefit-icons",
          label: "Benefit-Icons",
          routerLink: ["/extensions/cms/benefit-icons"],
          icon: "star",
          requiresPermission: "UpdateSettings"
        }
      ]
    },
    "settings"
  )
];
